// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CallLogPagingResultModel from '../../model/call-log-paging-result-model';
import CallLogPagingResultDTO from '../dto/call-log-paging-result-dto';
import CallLogModel from '../../model/call-log-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CallLogPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CallLogPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CallLogModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: CallLogModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<CallLogPagingResultDTO>): CallLogPagingResultModel;
  static toModel(dto: DeepPartial<CallLogPagingResultDTO> | undefined | null): CallLogPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CallLogPagingResultDTO> | undefined | null): CallLogPagingResultModel | undefined {
    return dto ? new CallLogPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CallLogPagingResultModel> | CallLogPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as CallLogPagingResultDTO;
  }
}
